import './services.css';
import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import Servicios from '../../Content/Services';

const Services = () => {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsIndex, setDetailsIndex] = useState(0);
  const [bgReady, setBgReady] = useState(() => new Set());

  const openDetails = (index) => {
    setDetailsIndex(index);
    setDetailsOpen(true);
  };

  const closeDetails = () => setDetailsOpen(false);

  const revealBg = useCallback((index) => {
    setBgReady((prev) => {
      if (prev.has(index)) return prev;
      const next = new Set(prev);
      next.add(index);
      return next;
    });
  }, []);

  useEffect(() => {
    const section = document.getElementById('servicios');
    if (!section) return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = Number(entry.target.getAttribute('data-srv-index'));
          if (!Number.isNaN(idx)) revealBg(idx);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '220px', threshold: 0.01 }
    );

    section.querySelectorAll('[data-srv-index]').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [revealBg]);

  useEffect(() => {
    if (!detailsOpen) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [detailsOpen]);

  const modal =
    detailsOpen &&
    createPortal(
      <div
        className="srv-modal-bg"
        role="dialog"
        aria-modal="true"
        aria-label="Detalle del servicio"
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) closeDetails();
        }}
      >
        <div className="srv-modal">
          <div className="srv-modal-head">
            <div className="srv-modal-title">
              <h3>{Servicios[detailsIndex]?.Name}</h3>
            </div>
            <button type="button" className="srv-modal-close" onClick={closeDetails} aria-label="Cerrar">
              ×
            </button>
          </div>

          <div className="srv-modal-body">
            <div
              className="srv-modal-content"
              dangerouslySetInnerHTML={{ __html: Servicios[detailsIndex]?.content ?? '' }}
            />
          </div>

          <div className="srv-modal-foot">
            <button type="button" className="srv-modal-back" onClick={closeDetails}>
              Cerrar
            </button>
          </div>
        </div>
      </div>,
      document.body
    );

  return (
    <>
      <section id="servicios" className='Services-Component'>
        <div className="srv-wrap">
          <div className="sec-head">
            <div className="sec-tag">Áreas de práctica</div>
          </div>

          <div className="srv-grid">
            {Servicios.map((servicio, index) => {
              return (
                <article
                  key={servicio.ID ?? index}
                  id={`srv-${index}`}
                  className={`srv${bgReady.has(index) ? ' srv--ready' : ''}`}
                  data-srv-index={index}
                  style={
                    bgReady.has(index) ? { '--srv-bg': `url(${servicio.Image})` } : undefined
                  }
                  role="button"
                  tabIndex={0}
                  aria-label={`Ver más sobre ${servicio.Name}`}
                  onClick={() => openDetails(index)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') openDetails(index);
                  }}
                >
                  <p className="srv-name">{servicio.Name}</p>

                  <div className="srv-actions">
                    <button
                      type="button"
                      className="srv-lnk"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDetails(index);
                      }}
                    >
                      Ver más
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </button>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
      {modal}
    </>
  );
};

export default Services;
